<script lant="ts">
import { PopupCart } from "./popup-cart";

export default PopupCart;
</script>

<template>
    <div class="header__popup-cart popup-cart">
        <div class="popup-cart__body">
            <div
                v-for="(item, index) in model.singleCartItems"
                :key="index"
                class="popup-cart__item"
            >
                <div
                    class="popup-cart__image"
                    :style="{
                        backgroundSize: 'cover',
                    }"
                    v-if="filterImages(item.stock.images).length"
                    v-app-fast-gallery="{ images: item.stock.images }"
                ></div>
                <div v-else class="popup-cart__image popup-cart-no-image"></div>
                <div class="popup-cart__info">
                    <p class="popup-cart__name">
                        {{ item.car.title }}
                    </p>
                    <p class="popup-cart__mode">
                        {{ item.car.description }}
                    </p>
                    <p class="popup-cart__price">
                        <app-format-currency
                            :value="
                                item.car.price_with_discount > 0
                                    ? item.car.price_with_discount
                                    : item.car.price || 0
                            "
                            :currency="model.currency"
                        />
                    </p>
                    <p class="popup-cart__mode">
                        <i18n-t keypath="myOrders.exclusiveVat" />
                    </p>
                </div>
                <div
                    class="popup-cart__delete"
                    @click="model.deleteSingleCar(item.id, item.stock.vin)"
                >
                    <svg class="sprite-icon cart__icon" width="17" height="17">
                        <use xlink:href="/img/sprite.svg#x-circle"></use>
                    </svg>
                </div>
            </div>
        </div>
        <div class="popup-cart__footer">
            <router-link to="/cart" class="button">
                <i18n-t keypath="cart.goToCart" />
            </router-link>
        </div>
    </div>
</template>
